import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import PropTypes from 'prop-types';

import { useModalDisplayedEvent } from '@zenbusiness/application-commons-clickstream';
import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import BasicDialog from '@zenbusiness/zui/BasicDialog';
import Chip from '@zenbusiness/zui/Chip';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import ConstructorCallout from '#client/components/ConstructorCallout';

const MESSAGE_KEY = 'shopping.page.registeredAgent.secondChance';

function SecondChanceModal({ open, onClose, onPrimaryAction, onSecondaryAction, price, loading }) {
  const { formatMessage } = useIntl();

  useModalDisplayedEvent({
    open,
    elementName: 'registered_agent_second_chance_modal'
  });

  return (
    <BasicDialog
      data-testid="registered-agent-second-chance-modal"
      open={open}
      overline={formatMessage({ id: `${MESSAGE_KEY}.overline` })}
      primaryAction={{
        loading,
        label: formatMessage({ id: `${MESSAGE_KEY}.primaryAction` }),
        onClick: onPrimaryAction,
        clickstreamProps: {
          elementName: 'registered_agent_second_chance_primary_action'
        },
        'data-testid': 'registered-agent-second-chance-primary-action'
      }}
      secondaryAction={{
        disabled: loading,
        label: formatMessage({ id: `${MESSAGE_KEY}.secondaryAction` }),
        onClick: onSecondaryAction,
        clickstreamProps: {
          elementName: 'registered_agent_second_chance_secondary_action'
        },
        'data-testid': 'registered-agent-second-chance-secondary-action'
      }}
      subtitle={formatMessage({ id: `${MESSAGE_KEY}.subtitle` })}
      title={formatMessage({ id: `${MESSAGE_KEY}.title` })}
      onClose={onClose}
    >
      <Stack spacing={2}>
        <div>
          <Chip color="warning" icon={<WarningRoundedIcon />} role="note">
            {formatMessage({ id: `${MESSAGE_KEY}.requirementChip` })}
          </Chip>
        </div>
        <Stack spacing={3}>
          <ConstructorCallout
            description={formatMessage({ id: `${MESSAGE_KEY}.callout.subtitle` }, { br: <br /> })}
            title={formatMessage({
              id: `${MESSAGE_KEY}.callout.title`
            })}
            type="warning"
          />
          <Text color="secondary" size="xs">
            <FormattedMessage
              id={`${MESSAGE_KEY}.billingDisclaimer.text`}
              values={{
                price
              }}
            />
          </Text>
        </Stack>
      </Stack>
    </BasicDialog>
  );
}

SecondChanceModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onPrimaryAction: PropTypes.func.isRequired,
  onSecondaryAction: PropTypes.func.isRequired,
  price: PropTypes.number.isRequired,
  loading: PropTypes.bool
};

export default SecondChanceModal;
